import React, { useState } from 'react'
import '../../assets/css/index.css'

import { useParams } from 'react-router-dom';

import moment from 'moment';

import { useGetByIdMutation, useGetSignedUrlMutation } from '../../store/api/endpoints/workshops'
import { useEffect } from 'react'
import { ProgressSpinner } from 'primereact/progressspinner';
import { Divider } from 'primereact/divider';


const Workshop = () => {

    const urlParams = useParams();

    const [
        getRegistro,
        {
            data: responseGetRegistro,
            error: errorGetRegistro,
            isLoading: isLoadingGetRegistro,
            isUninitialized: isUninitializedGetRegistro,
            isError: isErrorGetRegistro,
            isSuccess: isSuccessGetRegistro
        }
    ] = useGetByIdMutation()

    const [
        getVideoUrl,
        {
            data: responseGetVideoUrl,
            error: errorGetVideoUrl,
            isLoading: isLoadingGetVideoUrl,
            isUninitialized: isUninitializedGetVideoUrl,
            isError: isErrorGetVideoUrl,
            isSuccess: isSuccessGetVideoUrl
        }
    ] = useGetSignedUrlMutation()

    useEffect(() => {
        getRegistro({ id: urlParams.id })
    }, [])

    useEffect(() =>{
        if(isSuccessGetRegistro){
            const body = {url: responseGetRegistro?.data?.video}
            getVideoUrl({id: urlParams.id, body})
        }
    }, [isSuccessGetRegistro])

    if (isErrorGetRegistro) {
        return (
            <div align="center">
                <div style={{ width: '90%' }}>
                    <div style={{ marginTop: "50px" }}></div>
                    <div class="grid" style={{ width: '90%' }}>
                        <div class="col-12 md:col-12 lg:col-12">
                            {errorGetRegistro.status === 403 && <p>Para acceder aquí debes iniciar sesión.</p>}
                            {errorGetRegistro.status !== 403 && <p>Error al obtener el workshop.</p>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    if (isUninitializedGetRegistro || isLoadingGetRegistro) {
        return (
            <ProgressSpinner style={{ width: '100px', height: '100px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
        )
    }

    if (isSuccessGetRegistro) {

        const fechaFormateada = moment(responseGetRegistro.data.publicationDate).format('DD/MM/YYYY');

        return (
            <>
                <div align="center">
                    <div style={{ width: '90%' }}>
                        <div style={{ marginTop: "50px" }}></div>
                        <div class="grid">
                            <div class="col-12 md:col-5">
                                <p class="text-2xl text-center md:text-left">{responseGetRegistro.data.title}</p>
                                <Divider type="solid" layout="horizontal" />
                                <p class="text-1xl text-center md:text-left"><i className="pi pi-calendar" /> {fechaFormateada}</p>
                                <p class="text-1xl text-center md:text-left"><i className="pi pi-microphone" /> {responseGetRegistro.data.speaker}</p>
                                <p class="text-justify">{responseGetRegistro.data.description}</p>
                            </div>
                            <div class="col-12 md:col-7">
                                {
                                    (isUninitializedGetRegistro || isLoadingGetRegistro) && 
                                    <p class="text-justify">Cargando video...</p>
                                }
                                {
                                    isSuccessGetVideoUrl && 
                                    <video className="w-full h-auto border-round shadow-2" controls>
                                        <source src={responseGetVideoUrl.signedUrl} type="video/mp4" />
                                        Tu navegador no soporta la etiqueta de video.
                                    </video>
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </>
        )
    }
}

export default Workshop
